<template>
  <el-dialog class="modal-v2" :title="getTitle" :visible.sync="showDialog" :close-on-click-modal="false" width="420px" append-to-body v-dialog-drag>
    <div class="flex vertical acenter">
      <img src="@/air/assets/img/icon/warning-big.png" class="size40 mt20 mb16" />
      <div class="confirm-content mb20 pl40 pr40" v-html="content"></div>
    </div>
    <div slot="footer" class="w100 flex jend acenter">
      <el-button plain class="button-v2" @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" class="button-v2" :loading="submitLoading" @click="confirm">{{ $t('determine')  }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { validatenull } from "@/util/validate";

  export default {
  name: 'airConfirmV2',
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    confirmFunction: {
      type: Function,
      default () {
        return () => {
          console.log('confirm')
        }
      }
    }
  },
  data() {
    return {
      submitLoading: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    },
    getTitle() {
      return validatenull(this.title) ? this.$t('tips') : this.title;
    },
    getContent() {
      return validatenull(this.content) ? this.$t('confirmOperation') : this.content;
    },
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.submitLoading = false
      }
    }
  },
  methods: {
    confirm() {
      this.submitLoading = true
      this.confirmFunction()
      this.$emit('update:show', false)
    },
    cancel() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.air-modal {
  .air-modal-body {
    min-height: 132px;

    img {
      width: 40px;
      height: 40px;
      margin-top: 17px;
      margin-bottom: 16px;
    }
    .confirm-content {
      width: 372px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      text-align: center;
      white-space: pre-wrap;
      word-break: break-all;
    }
  }
}
</style>
